import { render, staticRenderFns } from "./generalDaif.vue?vue&type=template&id=c758a5f8&scoped=true&"
import script from "./generalDaif.vue?vue&type=script&lang=js&"
export * from "./generalDaif.vue?vue&type=script&lang=js&"
import style0 from "./generalDaif.vue?vue&type=style&index=0&id=c758a5f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c758a5f8",
  null
  
)

export default component.exports